import React from 'react';
import BrandGlyph from '../components/BrandGlyph';
import { PLATFORM_GLYPHS } from './assets';

// Brand icons via BrandGlyph's currentColor mask — see that component for the
// how and why. Same asset files as the event page's platform pills.
const brandIcon = (src) => {
  const BrandIcon = ({ className = 'w-6 h-6' }) => <BrandGlyph src={src} className={className} />;
  return BrandIcon;
};

export const FacebookIcon = brandIcon(PLATFORM_GLYPHS.facebook);
export const InstagramIcon = brandIcon(PLATFORM_GLYPHS.instagram);
export const TikTokIcon = brandIcon(PLATFORM_GLYPHS.tiktok);
export const XIcon = brandIcon(PLATFORM_GLYPHS.x);

export const SOCIAL_LINKS = [
  { label: 'Facebook',  handle: 'applausscom',  href: 'https://www.facebook.com/applausscom',  Icon: FacebookIcon },
  { label: 'Instagram', handle: '@applausscom', href: 'https://www.instagram.com/applausscom', Icon: InstagramIcon },
  { label: 'TikTok',   handle: '@applausscom', href: 'https://www.tiktok.com/@applausscom',   Icon: TikTokIcon },
  { label: 'X',        handle: '@applausscom', href: 'https://x.com/applausscom',             Icon: XIcon },
];
